import store from '../store';

export default function (to, from, next) {
	const user = store.state.user.user;

	if (user) {
		next();
	} else {
		if (from.name === 'login') {
			store.dispatch('CHANGE_LOADING_STATE', false);
		}
		next({ name: 'login' });
	}
}